import React from 'react';

const OverviewCards = ({ stats }) => {
  return (
    <div className="overview-cards">
      <div className="stat-card">
        <div className="stat-icon">
          <i className="fas fa-briefcase"></i>
        </div>
        <div className="empinfo">
          <h3>{stats.totalProjects}</h3>
          <p>Total Projects</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">
          <i className="fas fa-rocket"></i>
        </div>
        <div className="empinfo">
          <h3>{stats.activeProjects}</h3>
          <p>Active Projects</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">
          <i className="fas fa-users"></i>
        </div>
        <div className="empinfo">
          <h3>{stats.totalEmployees}</h3>
          <p>Total Employees</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">
          <i className="fas fa-tasks"></i>
        </div>
        <div className="empinfo">
          <h3>{stats.pendingTasks}</h3>
          <p>Pending Tasks</p>
        </div>
      </div>
    </div>
  );
};

export default OverviewCards;
